import React from 'react';
import { Link } from 'react-router-dom';
import ScrollReveal from '../components/ScrollReveal';
import { useLanguage } from '../i18n/LanguageContext';

export default function Products() {
  const { t } = useLanguage();
  const p = t.products;

  return (
    <section id="products" className="page-section bg-light">
      <div className="container">
        <ScrollReveal className="section-head center">
          <span className="section-eyebrow">{p.eyebrow}</span>
          <div className="accent-line center" />
          <h2 className="section-title">{p.title}</h2>
          <p className="section-sub">{p.sub}</p>
        </ScrollReveal>
        <div className="products-grid">
          {p.items.map((item, i) => (
            <ScrollReveal key={item.id} delay={i * 60}>
              <Link to={`/products/${item.id}`} className="product-card" id={item.id}>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
                <div className="prod-tags">
                  {item.tags.map(tag => <span key={tag} className="prod-tag">{tag}</span>)}
                </div>
              </Link>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
